import * as Cesium from "cesium";
import gsap from "gsap";
import { CENTER } from "./effectConfig";

/**
 * 光锥：优先加载 pyramid.glb；失败则用圆锥实体兜底
 * options.color / scale / heightBase / lng / lat
 */
export default class LightCone {
  constructor(viewer, options = {}) {
    this.viewer = viewer;
    this.lng = options.lng ?? CENTER.lng;
    this.lat = options.lat ?? CENTER.lat;
    this.groundHeight = options.groundHeight ?? 1110;
    this.color = options.color ?? Cesium.Color.YELLOW;
    this.scale = options.scale ?? 350;
    this.heightBase = options.heightBase ?? this.groundHeight + 180;
    this.params = {
      height: this.heightBase,
      degress: 0,
    };
    this.model = null;
    this.entity = null;
    this._init();
  }

  _matrix(height, heading) {
    return Cesium.Transforms.headingPitchRollToFixedFrame(
      Cesium.Cartesian3.fromDegrees(this.lng, this.lat, height),
      new Cesium.HeadingPitchRoll(heading, 0, 0)
    );
  }

  async _init() {
    try {
      this.model = await Cesium.Model.fromGltfAsync({
        url: `${process.env.BASE_URL}model/pyramid.glb`,
        show: true,
        scale: this.scale,
        minimumPixelSize: 64,
        maximumScale: 50000,
        color: this.color.withAlpha(0.65),
        colorBlendMode: Cesium.ColorBlendMode.MIX,
        modelMatrix: this._matrix(this.params.height, this.params.degress),
      });
      this.viewer.scene.primitives.add(this.model);
      this.animate();
      console.log("[LightCone] glb 已加载");
    } catch (e) {
      console.warn("[LightCone] glb 失败，改用 Cone 实体:", e);
      this._createFallbackEntity();
      this.animate();
    }
  }

  _createFallbackEntity() {
    this.entity = this.viewer.entities.add({
      position: new Cesium.CallbackProperty(() => {
        return Cesium.Cartesian3.fromDegrees(
          this.lng,
          this.lat,
          this.params.height
        );
      }, false),
      orientation: new Cesium.CallbackProperty(() => {
        return Cesium.Transforms.headingPitchRollQuaternion(
          Cesium.Cartesian3.fromDegrees(this.lng, this.lat, this.params.height),
          new Cesium.HeadingPitchRoll(this.params.degress, 0, 0)
        );
      }, false),
      cylinder: {
        length: 400,
        topRadius: 0.0,
        bottomRadius: 120.0,
        material: this.color.withAlpha(0.45),
        outline: false,
      },
    });
  }

  animate() {
    const base = this.heightBase;
    gsap.to(this.params, {
      height: base + 120,
      degress: Math.PI * 2,
      yoyo: true,
      repeat: -1,
      duration: 2,
      ease: "power1.inOut",
      onUpdate: () => {
        if (this.model) {
          this.model.modelMatrix = this._matrix(
            this.params.height,
            this.params.degress
          );
        }
      },
    });
  }

  setVisible(show) {
    if (this.model) this.model.show = show;
    if (this.entity) this.entity.show = show;
  }
}
